<template>
    <div class="page error-page">

        <!-- 페이지 없음 : 없는 경로로 접근할 경우 -->
        <div>
            <img src="@/assets/images/bayer/error/empty_box.png" alt="empty_box">

            <h1>페이지를 찾을 수 없습니다.</h1>
            <p>
                주소가 잘못 입력되었거나 변경 또는 삭제되어 요청하신 페이지를 찾을 수 없습니다. 뒤로 돌아가주시거나 서비스 관리자에게 문의해주세요.
            </p>
        </div>

        <!-- 잘못된 접근 :  -->
        <!-- <div>
            <img src="@/assets/images/bayer/error/error.png" alt="error">

            <h1>잘못된 접근입니다</h1>
            <p>
                서비스 이용에 불편을 드려 죄송합니다. 찾으시려는 페이지는 잘못된 접근이거나 경로에 오류가 있습니다. 서비스 관리자에게 문의해주세요.
            </p>
        </div> -->

        <!-- 시스템 점검 :  -->
        <!-- <div>
            <img src="@/assets/images/bayer/error/warning.png" alt="warning">

            <h1>시스템 점검</h1>
            <p>
                서비스 이용에 불편을 드려 죄송합니다. <br />
                <span class="red-text">
                    <b>점검시간</b> <br />
                    24년 02월 27일 23시~ 02월 28일 01시
                </span>
            </p>
        </div> -->

        <!-- 시스템 장애 :  -->
        <!-- <div>
            <img src="@/assets/images/bayer/error/failure.png" alt="failure">

            <h1>시스템 장애</h1>
            <p>
                바이엠팜에 연결할 수 없습니다. 일시적인 장애이거나 네트워크 문제일 수 있습니다. 잠시 후 다시 이용해주세요.
            </p>
        </div>

        -->

        <div class="bottom-btn">
            <v-btn color="primary" x-large depressed block rounded @click="clickCancel">
                뒤로
            </v-btn>

        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.error-page {
    position: absolute;
    height: 100vh;
    padding: 20px;
    text-align: center;

    img {
        width: 100%;
        max-width: 250px;
        margin: 30px 0 40px;
    }

    .bottom-btn {
        margin-top: 40px;
    }

}
</style>